import React, { useEffect } from 'react';
import { List, Icon, IconButton } from '@material-ui/core';
import withRouter from 'react-router-dom/withRouter';
import DocumentListItem from './listitem';
import withInfiniteScroll from 'global/components/withInfiniteScroll';
import { get, set } from 'global/lib/lodash';
import useStyles from './styles';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { Loader } from 'global/styles';
import { CenterContent, GridContainer } from 'global/components/perform-grid';
import clsx from 'clsx';
import { ListItem } from '../CourseList/listitem';
import { Row } from 'global/components/row';
import { useScreen } from 'global/styles';
import { sortByOrderKey } from 'global/utils';

const include = ['edition', 'edition.documents', 'edition.documents.document', 'edition.documents.superset', 'edition.documents.reads', 'assessment', 'user'].join(',');

export const sortDocs = (docs) => {
  return docs.sort(sortByOrderKey);
};

export const TransformDocs = (d) => {
  const data = get(d, '0', {});

  const docs = sortDocs(get(data, 'edition.documents', []));

  const docswithdividers = [];

  docs.map((doc, i) => {
    const prevDoc = docs[i - 1];

    const prevSuper = get(prevDoc, 'superset.id');

    if (!prevDoc || prevSuper !== get(doc, 'superset.id')) {
      docswithdividers.push({ id: '_divider_', title: get(doc, 'superset.name') });
    }

    docswithdividers.push(doc);
  });

  set(data, 'edition._documents', docswithdividers);

  return data;
};

export const CourseEditionList = withRouter((props) => {
  const { isDocumentPath } = props;
  const libid = get(props, 'match.params.id', 0);
  const { isMobile } = useScreen();
  const classes = useStyles({ isMobile });

  const locationProps = get(props, 'location.state', {});

  const ed = useRetrieveData(
    { url: `/course-assignments/${libid}` },
    {
      build: ['courseAssignments'],
      params: {
        include,
        filter: {
          role: locationProps.isReview ? 'reviewer' : undefined,
        },
      },
      transformData: TransformDocs,
    }
  );

  useEffect(() => {
    window.CourseEditionUpdate = ed.update;

    return () => {
      delete window.CourseEditionUpdate;
    };
  }, []);

  const onClose = () => {
    const { fromLibrary } = locationProps;
    if (fromLibrary) {
      props.history.push('/library', locationProps);
    } else {
      props.history.push('/courses', locationProps);
    }
  };

  return (
    <GridContainer fullWidth={isDocumentPath}>
      <CenterContent selfCenter fullWidth={isDocumentPath}>
        <div className={isDocumentPath ? clsx(classes.sidebarWidth, classes.list) : clsx(classes.fullWidth)}>
          <Row fullWidth>
            <IconButton classes={{ root: classes.closeIcon }} onClick={onClose}>
              <Icon>chevron_left</Icon>
            </IconButton>
            {ed.loading ? <Loader size={30} /> : <ListItem item={ed.data} disabled isMobile={isDocumentPath} showSecondRow={!isDocumentPath} />}
          </Row>

          <ScrollList loading={ed.loading} data={get(ed, 'data.edition._documents', [])} alwaysReplaceData={true} />
        </div>
      </CenterContent>
    </GridContainer>
  );
});

const ScrollList = withInfiniteScroll(DocumentListItem, List);
